module.exports = __webpack_public_path__ + "static/img/tourimg-1.d4b0406.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/tourimg-1.png
// module id = 8R5V
// module chunks = 1